<template>
  <div
    class="grm-video-layer one-fourth column flex justify-center items-center"
    data-grm-comp="RoomCallVideo.p2p"
    ref="roomCallVideo"
    :data-user-id="user.userId"
    :data-screen-share="user.screenShare"
    @click="onClick"
  >
    <StopWatch :user="user"/>
    <div class="relative w-full h-full"
         ref="roomVideoWrapper"
    >
      <RoomVideo class="grm-video"
        v-if="stream"
        ref="video"
        :style="roomVideoStyle"
        :muted="true"
        :videoOnly="videoOnly"
        :myVideo="isMe"
        @resize="onRoomVideoResize"
        @playing="onRoomVideoResize"
      ></RoomVideo>

      <!--
      <GrmDraggableResizable v-if="isMe && roomInfoSetting.useScreenMerger && localStream && isRoomMode('screenShare')"
                             :parent="true"
                             :w="screenSharePip.width"  :h="screenSharePip.height"
                             :x="screenSharePip.x"      :y="screenSharePip.y"
                             :lock-aspect-ratio="screenSharePip.lockAspectRatio"
                             :onResize="onResize"
                             :onDrag="onDrag"
      >
        <RoomVideo class="grm-video"
                   ref="localVideo"
                   :stream="localStream"
                   :style="roomVideoStyle"
                   :muted="isMuted"
                   :videoOnly="videoOnly"
        ></RoomVideo>
      </GrmDraggableResizable>
      -->

    </div>

    <div
      class="v-bg"
         v-if="!isScreenShare"
         :class="{
            'no-cam': !!roomUser && roomUser.roomUserRole.camera==false || roomUser.cameraStatus != 'on',
            'no-user': !roomUser
          }"
    >
      <img v-if="!roomUser" class="pointer-events-none"
           :style="ux.useNoneVideoImageFull && ux.noneVideoImagePath ? {
              width: '100%',
              height: '100%',
              objectFit: 'cover'
           } : {
              height: '40%'
           }"
           :src="ux.noneVideoImagePath || require('@/assets/roomType/lms/img/v-img/user1.svg')"
      />
    </div>

    <template v-if="!!roomUser">
      <div class="v-peakmeter" :class="{ active: roomUser && roomUser.isSpeaking && !isScreenShare }"></div>
      <div class="v-dim" v-if="!isScreenShare"></div>
      <div class="v-name-area">
        <div class="v-name ep flex items-center" :class="{ isMe }">
          <GrmIcon icon="opener"
                   v-if="isOpener(roomUser.userId)"
                   class="mr-1"
          />
          <p class="room-user-nickname min-w-0 max-w-max flex-1 truncate"
             v-tooltip.top="roomUser.nickname"
					>{{ roomUser.nickname }}</p>
        </div>
        <!--
        <div class="v-mic-off"
             v-if="(roomUser.micStatus === 'off' || roomUser.micStatus === 'none' || roomUser.roomUserRole.mic === false) && !isScreenShare"
        >
          <img src="@/assets/roomType/lms/img/icon_mic_off.svg" />
        </div>
        -->
      </div>
      <RoomSticker class="absolute inset-0" :sticker-id="roomUser.stickerId" />
    </template>
    <RoomCallScreenShare v-if="user.screenShare" :userId="user.userId" />
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {GrmWebRTC} from '@/lib/gooroomee/webrtc/GrmWebRTC'
import RoomVideo from "@/components/Room/Call/RoomVideo";
import RoomCallScreenShare from '@/components/Room/Call/RoomCallScreenShare.vue'
import _ from "lodash";
import {RoomCall} from "@/core/api/room.call.api";
import GrmIcon from "@/components/Common/icon/GrmIcon";
import RoomSticker from "@/components/Room/Sticker/RoomSticker.vue";
import StopWatch from "@/components/Room/Camstudy/StopWatch.vue";
// import GrmDraggableResizable from "@/components/Common/draggableResizable/GrmDraggableResizable.vue";

export default {
  name: 'RoomCallP2PVideo',
  components: {
    StopWatch,
    GrmIcon,
    RoomVideo,
    RoomSticker,
    RoomCallScreenShare,
    // GrmDraggableResizable,
  },
  props: {
    user: {
      type: Object,
      default: function(){
        return {
          userId: null,
          screenShare: false,
          _createdAt: 0
        };
      }
    },
    videoOnly: {
      type: Boolean,
      default: false
    },
    defaultVideoObjectFit: {
        type: String,
        default: ''
    }
  },
  data() {
    return {
      stream: null,
      localStream: null,
      screenSharePip: {
        x: 0,
        y: 0,
        width: 10,
        height: 10,
        minWidth: 1,
        lockAspectRatio: false,
      },
      videoObjectFit: undefined
    }
  },

  created() {
    console.log('RoomCallVideo created : userId[%s], nickname[%s], screenShare[%s]',
        this.user?.userId, this.roomUser?.nickname,
        this.isScreenShare)
    this.$roomApi.addEventListeners((this._Events = _Events()), this)
  },

  mounted() {
    this.setStream();

    this.getDefaultView().addEventListener('resize', (this._w_resize=e => {
      clearTimeout(this._resizeTimer)
      this._resizeTimer = setTimeout(() => {
        this.onRoomVideoResize();
      }, 100)
    }));

    this.$emit('mounted', this);
  },

  destroyed() {
    this.$roomApi.removeEventListeners(this._Events)
    this.getDefaultView().removeEventListener('resize', this._w_resize);

    try{
      this.onRoomVideoResize({
        type: 'GrmDomIntersect',
        isIntersecting: false
      });
    }catch(e){
      console.warn(e);
    }

    this.$emit('destroyed', this);
  },

  computed: {
    ...mapGetters('user', [
      'me',
      'isOpener',
      'getRoomUser',
      'hasEmceeRole',
      'hasSpeakerRole',
      'isParticipantRole',
    ]),
    ...mapGetters('room', [
      'lowPowerMode',
      'isRoomMode',
      'deviceSettings',
      'isScreenShareMode',
      'roomInfoSetting',
      'isCamStudy'
    ]),
    ...mapGetters('call', [
      // 'getUserVideoStream',
      // 'getUserScreenStream'
    ]),
    ...mapGetters('ux', [
      'ux',
    ]),
    
    roomUser() {
      let userId = this.user?.userId;
      if(!userId){
        return;
      }
      let roomUser = this.getRoomUser(userId);
      return roomUser;
    },
    isMe() {
      return this.roomUser && this.roomUser.userId === this.me.userId;
    },
    isMyScreenShareView() {
      return this.isRoomMode('screenShare') && this.isScreenShareMode;
    },
    isSpeakerOff(){
      return this.me.speakerStatus != 'on';
    },
    isMuted(){
      return this.isMe || this.isSpeakerOff;
    },
    roomVideoStyle() {
      if(this.isScreenShare){
        return{};
      }else{
        const style = {
          'transform': this.isMe && this.deviceSettings.video.usePreviewMirror
                      ? 'scaleX(-1)' : '',
        }
        let videoObjectFit = this.videoObjectFit;
        if(videoObjectFit === undefined){
          videoObjectFit = this.defaultVideoObjectFit;
        }
        if(videoObjectFit){
            style.objectFit = videoObjectFit;
        }
        return style;
      }
    },
    isScreenShare() {
      // return !this.videoOnly
      //     && !!this.roomUser?.screenStatus;
      return !this.videoOnly
          && (!!this.user?.screenShare || !!this.user?.screenStatus);
    },
  },

  watch: {
    lowPowerMode: {
      handler: function(level) {
        this.onRoomVideoResize({}, {force: true})
      }
    },
    'user.userId': {
      // immediate: true,
      handler: function(userId, old) {
        if(!userId){
          this.stream = null;
          return;
        }
        this.setStream();
      }
    },
    'user.screenShare': {
      handler: function(screenShare, old){
        if(screenShare){
          console.log('RoomCallVideo screenShare :', screenShare)
        }
        this.setStream();
      }
    },
    stream: function(stream, prev) {
      if (!stream) {
        return;
      }
      // console.log('@@@@@@@@@@@@@@', this.user?.userId, stream === prev, stream, prev)
      this.$nextTick(async () => {
        await this.setStream(stream);
      })
    },
  },

  methods: {
    ...mapActions('room', [
      'toggleUserMixingVideoByUserId'
    ]),
    ...mapActions('call', [
      'getUserVideoStream',
      'getUserScreenStream',
      'resizeMergedStream',
      'moveMergedStream',
      'updateMergedScreenStream',
      'getStreamMergerMatrix',
      'getVideoOnlyStream',
      'changeVideoSenderMaxBitrateFromDomElement',
      'getP2PUserCurrentConnectionStats',
    ]),
    ...mapActions('roomGroup', [
      'setRoomUserGroup'
    ]),
    onClick: function(e){
      this.$emit('click', this.user);

      this.onRoomVideoResize(e, {force: true});
      (() => {
        if(this.isIntersecting === false) return;
        let video = this?.$refs?.video?.$refs?.video;
        if(!video || !video.paused || video.offsetWidth === 0) return;
        video.play().catch(e => {
          console.warn(e)
        });
      })();
    },
    setStream: async function(){
      const userId = this.user?.userId;
      let refs = {};

      this.localStream = null;
      if(userId){
        if(this.isScreenShare){
          this.stream = await this.getUserScreenStream({userId});
          if(this.isMe){
            refs.localVideo = this.localStream = await this.getUserVideoStream({userId});
          }
        }else{
          let stream = await this.getUserVideoStream({userId});
          // this.stream = await this.getVideoOnlyStream({stream});
          this.stream = stream;
        }
      }else{
        this.stream = null;
      }
      refs.video = this.stream;
      Object.entries(refs).forEach(([ref, stream])=>{
        const video = this.$refs[ref]?.$refs.video;
        if (!video) return;
        if (video.paused && video.srcObject) {
          video.play().catch(e => {
              if(!e.message || e.message.includes('interrupted')){
                  return;
              }
              console.warn(video, e)
          });
        }

        if(!stream){
          console.warn('call stream is null', this.isScreenShare, this.user);
          video.srcObject = null;
          return;
        }

        if(video.srcObject === stream){
          return;
        }

        // console.log('video set stream : ', this.isScreenShare, this.user)

        function checkError(e){
          if(e.message.includes('aborted')){
            // 자동 재생 문제
            if(!video.muted){
              console.error(this.$t('call.error.autoplay'));
              return;
            }
          }else if(e.message.includes('interrupted by ')){
            // ignore
          }else{
            console.error(e);
          }
        }

        delete video._r_width;
        delete video._r_height;

        GrmWebRTC.attachMediaStream(video, stream)
        video.play().then(() => {
          this.onRoomVideoResize()
        }).catch(checkError);

        const vTrack = stream.getVideoTracks()[0];
        if(vTrack && vTrack.muted){
          this.onRoomVideoResize(null, {immediate: true})
        }
      })
    },
    async updatePipLocation(){
      await this.updateMergedScreenStream();

      const roomVideoWrapper = this.$refs?.roomVideoWrapper;
      if(!roomVideoWrapper) return;

      const {clientWidth, clientHeight} = roomVideoWrapper;
      const {canvasRatioX, canvasRatioY, canvasRatioWidth, canvasRatioHeight} = await this.getStreamMergerMatrix();

      this.screenSharePip.lockAspectRatio =  false;
      this.screenSharePip.x = clientWidth * canvasRatioX;
      this.screenSharePip.y = clientHeight * canvasRatioY;
      this.screenSharePip.width = clientWidth * canvasRatioWidth;
      this.screenSharePip.height = clientHeight * canvasRatioHeight;
      this.$nextTick(() => {
        this.screenSharePip.lockAspectRatio =  true;
      });

    },
    async onRoomVideoResize(e, options={immediate: false, force: false}) {
      const changeVisible = e?.type === 'GrmDomIntersect' && !this.isIntersecting && e.isIntersecting;

      // intersecting 값 관련하여 최초에 설정해야 함. 위치 고정.
      if(e?.type === 'GrmDomIntersect') {
        this.isIntersecting = e.isIntersecting;
      }

      // ch bandwidth method / debounce
      (() => {
        this._chBandWidth = this._chBandWidth || function({videoWidth, videoHeight, bitrate, framerate, degradationPreference}){
          let data = {
            userId: this.user.userId,
            el: this.$el,
            videoWidth, videoHeight, bitrate, framerate, degradationPreference
          }
          // console.trace('@@@@@@@@@@@@ s2', e?.type, this.$el, data);
          if(!this.user.screenShare){
            // RoomCall.changeVideoSenderMaxBitrate(data)
            this.changeVideoSenderMaxBitrateFromDomElement(data);
          }else{
            this.changeVideoSenderMaxBitrateFromDomElement({
              userId: this.user.userId,
              el: this.$el,
              bitrate: 0
            });
            RoomCall.changeSecondVideoSenderMaxBitrate(data)
          }

          // check bandwidth
          (() => {
            if(this.isMe || !changeVisible || bitrate <= 10){
              return;
            }

            const checkTimer = (loop) => {
              loop = (loop || 0)+1;
              clearTimeout(this._timer_video_monitor);
              this._timer_video_monitor = setTimeout(async () => {
                if(!this.$el?.isConnected || !this.isIntersecting) return;
                const ru = this.roomUser;
                if(!ru) return;
                const connStats = await this.getP2PUserCurrentConnectionStats(ru.userId);
                if(!connStats){
                  checkTimer(loop);
                  return;
                }

                let bw = connStats.video?.receive?.availableBandwidthKbps || 0;
                if(bw < 5){
                  console.warn('wrong video bw: userId[%s], name[%s], bw[%s] -> req[%s], loop[%s]', ru.userId, ru.nickname, bw, bitrate, loop);
                  this._chBandWidth({videoWidth, videoHeight, bitrate, framerate, degradationPreference})
                  if(loop > 10){
                    return;
                  }
                  checkTimer(loop);
                }else if(loop <= 2){
                  checkTimer(loop);
                }
              }, 1000*5);
            };
            checkTimer();
          })();
        };
        this._chBandWidthDebounce = this._chBandWidthDebounce || _.debounce(({videoWidth, videoHeight, bitrate, framerate, degradationPreference}) => {
          // console.trace('@@@@@@@@@@@@ s1', e.type, this.user.userId, {videoWidth, videoHeight, bitrate, framerate, degradationPreference});
          this._chBandWidth({videoWidth, videoHeight, bitrate, framerate, degradationPreference});
        }, 100);
      })();

      let video = this?.$refs?.video?.$refs?.video;
      if (this.isIntersecting && video && video.paused && video.srcObject) {
        video.play().catch(e => {
            if(!e.message || e.message.includes('interrupted')){
                return;
            }
            console.warn(video, e)
        });

      }

      // // fit video
      // if(this.isIntersecting && video && !video.paused){
      //   let width = Math.abs(video.videoWidth - this.$el.offsetWidth);
      //   let height = Math.abs(video.videoHeight - this.$el.offsetHeight);
      //   let ratio = video.videoWidth > 0 && video.videoWidth / video.videoHeight;
      //   if((width > 0 && width < 4) || (height > 0 && height < 4) && ratio > 1){
      //     this.videoObjectFit = 'cover';
      //   }else{
      //     this.videoObjectFit = 'contain';
      //   }
      // }

      video = video || this.$refs.roomVideoWrapper;
      if (!video){
        this._chBandWidthDebounce.cancel();
        this._chBandWidth({
          videoWidth:0, videoHeight:0,
          bitrate:0, framerate:1
        });
        return;
      }

      this.resizeRoomVideoWrapper();
      if (this.isScreenShare) {
        if (this.roomInfoSetting.useScreenMerger && this.isMe) {
          return this.updatePipLocation();
        }
      }

      // console.log('@@@@ resize event :', e, options)
      if(e?.type === 'GrmDomIntersect'){
        if(!e.isIntersecting){
          video._r_width = video._r_height = 0;
          this._chBandWidthDebounce({bitrate:0, framerate:1});
          return;
        }
      }else{
        if(this.isIntersecting === false){
          return;
        }
      }

      const videoWidth = video.offsetWidth, videoHeight = video.offsetHeight;
      if(options.force !== true){
        if(video._r_width == videoWidth && video._r_height == videoHeight){
          return;
        }
      }
      video._r_width = videoWidth;
      video._r_height = videoHeight;

      let bitrate = 128, framerate = 20, degradationPreference = 'balanced';
      if(videoWidth <= 100){
        bitrate = 100;
        framerate = 10;
      }else if(videoWidth <= 200){
        bitrate = 128;
        framerate = 13;
      }else if(videoWidth <= 320){
        bitrate = 160;
        framerate = 15;
      }else if(videoWidth <= 400){
        bitrate = 256;
        framerate = 15;
      }else if(videoWidth < 640){
        bitrate = 382;
        framerate = 15;
      }else if(videoWidth <= 1024){
        bitrate = 512;
      }else if(videoWidth < 1280){
        bitrate = 768;
      }else{
        bitrate = 1024;
      }

      if(screen.width > 1920){
        bitrate *= (1920 / screen.width * 1.2);
      }
      if(this.isCamStudy){
        let lowPowerMode = this.lowPowerMode;
        if(lowPowerMode > 0){
          bitrate = 20;
          framerate = Math.min(framerate, 4);
          degradationPreference = 'maintain-framerate'
          if(document.visibilityState === 'hidden'){
            bitrate = 0;
          }else if(lowPowerMode == 1){
            bitrate = 20;
            framerate = Math.min(framerate, 4);
          }else if(lowPowerMode > 1){
            bitrate = 10;
            framerate = Math.min(framerate, 3);
          }
        }else{
          let minBitrate = 50;
          bitrate = Math.max(bitrate / 2.5, minBitrate);
          framerate = Math.min(framerate, 5);
        }
      }

      if(options?.immediate === true){
        this._chBandWidthDebounce.cancel();
        this._chBandWidth({videoWidth, videoHeight, bitrate, framerate, degradationPreference});
      }else{
        this._chBandWidthDebounce({videoWidth, videoHeight, bitrate, framerate, degradationPreference});
      }
    },
    onResize(handle, x, y, width, height){
      if(!this.roomInfoSetting.useScreenMerger) return

      const roomVideoWrapper = this.$refs?.roomVideoWrapper;
      if(!roomVideoWrapper) return;

      const {clientWidth, clientHeight} = roomVideoWrapper;
      this.resizeMergedStream({
        ratioX: x / clientWidth,
        ratioY: y / clientHeight,
        ratioWidth: width / clientWidth,
      })
    },
    onDrag(x, y){
      if(!this.roomInfoSetting.useScreenMerger) return

      const roomVideoWrapper = this.$refs?.roomVideoWrapper;
      if(!roomVideoWrapper) return;

      const {clientWidth, clientHeight} = roomVideoWrapper;
      this.moveMergedStream({
        ratioX: x / clientWidth,
        ratioY: y / clientHeight
      })
    },
    resizeRoomVideoWrapper() {
      const roomVideoWrapper = this.$refs?.roomVideoWrapper;
      if (!this.isScreenShare) {
        if(roomVideoWrapper){
          roomVideoWrapper.style.width = roomVideoWrapper.style.height = null
        }
        return
      }
      
      const roomCallVideo = this.$refs?.roomCallVideo;
      const roomCallVideoRatio = roomCallVideo.clientWidth / roomCallVideo.clientHeight;

      const video = this?.$refs?.video?.$refs?.video;
      const videoTrackSettings = video.srcObject.getVideoTracks()[0].getSettings();
      const videoTrackRatio = videoTrackSettings.width / videoTrackSettings.height;

      // if (videoTrackRatio === 16 / 9) {
      //   return;
      // }

      roomVideoWrapper.style.width = videoTrackRatio >= roomCallVideoRatio ? '100%' : 'auto';
      roomVideoWrapper.style.height = videoTrackRatio > roomCallVideoRatio ? 'auto' : '100%';
    }
  }
}

function _Events(){
  return {
    room_call_loadLocalStreamStart: function() {
      if (!this.isMe) return
    },
    room_call_loadLocalStream: function(e) {
      if (!this.isMe) return
      // this.stream = e.data.stream;
      this.setStream();
    },
    room_core_call_changeUserStream: function(e) {
      if (!this.isMe) return
      const {stream} = e.data;
      if(this.stream.getVideoTracks()[0] !== stream.getVideoTracks()[0]) {
        this.setStream();
      }
    },
    room_call_loadScreenShareStream: function(e) {

    },
    room_call_userConnectionConnected: function(e) {
      if(this.user?.userId !== e.data.userId){
        return;
      }
      this.setStream();
    },
    room_call_userConnectionDisconnected: function(e) {
      if(this.user?.userId !== e.data.userId){
        return;
      }
    },
    room_call_userVideoStream: function(e) {
      if(this.user?.userId !== e.data.userId){
        return;
      }
      if(this.isScreenShare){
        return;
      }
      this.setStream();
    },
    room_call_userSecondStream: function(e) {
      if(this.user?.userId !== e.data.userId){
        return;
      }
      if(!this.isScreenShare){
        return;
      }
      this.setStream();
    },
    room_call_screenShare: function(e) {
      if(this.user?.userId !== e.data.userId){
        return;
      }
      this.setStream();
    }
  }
}
</script>

<style lang="scss" scoped>
.grm-video-layer {
  position: absolute !important;
  margin: 0 !important;
  box-sizing: content-box !important;

  &[draggable="true"] {
    &.no-user{
      cursor: default;
    }
    cursor: grab;
  }

  .grm-video {
    //width: 100%;
    //height: 100%;
    width: inherit;
    height: inherit;
    pointer-events: none;
  }
  .fitVideo {
    object-fit: cover;
  }

  .grm-video-layer-border {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    margin: 0;
    border-bottom: 1px solid #0c0c0c;
    border-right: 1px solid #0c0c0c;
    box-sizing: border-box;
    pointer-events: none;
  }

  .v-peakmeter {
    pointer-events: none;
  }

  .video-del {
    z-index: 1;
  }
}

.one-fourth.column {
  position: relative;
  background-color: #394050;

  &.sub-video{
    cursor: pointer;
  }
  *{
    //pointer-events: none;
  }
  .network-off {
    position: absolute;
    top: 20px;
    left: 20px;
  }

  .v-bg {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;

    &.no-user {
      background-color: #394050;
    }

    &.no-cam {
      background: #222 url('~@/assets/roomType/lms/img/video-off.svg') no-repeat center / auto 36%;
    }
  }

  .v-dim {
    position: absolute;
    left: 0;
    right: 0;
    height: 16%;
    min-height: 40px;
    bottom: 0;
    background: linear-gradient(
            360deg,
            rgba(0, 0, 0, 0.4) 0%,
            rgba(0, 0, 0, 0) 100%
    );
  }

  .v-peakmeter {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 3px solid $mainColor;
    z-index: 1;
    opacity: 0;
    transition: 0.2s ease-out;
    &.active {
      opacity: 1;
    }
  }

  .v-name-area {
    width: 100%;
    padding: 0 8px 8px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 0 6px;
    position: absolute;
    bottom: 0px;
    box-sizing: border-box;
    text-align: left;

    .v-name {
      min-width: 0;
      flex: 1;
      color: white;
      font-size: 12px;
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      .speaker-img {
        width: 15px;
        height: 15px;
        vertical-align: -2px;
      }

      &.isMe {
        color: #fff700;
      }
    }

    .v-mic-off {
      width: 20px;
      height: 20px;
    }
  }

  .video-del {
    position: absolute;
    top: 15px;
    right: 15px;
    cursor: pointer;
    display: none;
  }

  .room-user-nickname {
    pointer-events: auto;
  }
}

.one-fourth.column:hover .video-del {
  display: block;
}

.v-participation {
  position: absolute;
  top: 60%;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: .4;
  z-index: 1;
}
</style>